import { useMemo } from 'react';

export const useSharedRef = (a, b) => {
  const ref = useMemo(() => {
    if (a === null && b === null) {
      return null;
    }

    return refValue => {
      if (typeof a === 'function') {
        a(refValue);
      } else if (a) {
        a.current = refValue;
      }
      if (typeof b === 'function') {
        b(refValue);
      } else if (b) {
        b.current = refValue;
      }
    };
  }, [a, b]);

  return ref;
};
